import LegalPage from '../components/ui/LegalPage.jsx'

export default function Disclaimer() {
  return (
    <LegalPage
      title="Disclaimer"
      description="FastAudio Disclaimer — copyright responsibility, accuracy of results, and external links policy for the conversion service."
      slug="disclaimer"
      lastUpdated="January 2025"
    >
      <p>
        The information and tools provided on FastAudio are for general informational and
        personal use only. By using this service, you agree that FastAudio bears no
        responsibility for how you use converted media.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Copyright Responsibility</h2>
      <p>
        FastAudio does not host, store, or distribute copyrighted content. All media is
        fetched from third-party platforms at the user's explicit request. Users are solely
        responsible for ensuring they have the rights to download and use any content
        they convert through this service.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Accuracy</h2>
      <p>
        While we strive to provide accurate, reliable conversions, we do not guarantee the
        availability, quality, or completeness of any converted file. Platform changes or
        access restrictions may affect service availability at any time.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">External Links</h2>
      <p>
        This site may contain links to third-party websites. We have no control over and
        assume no responsibility for the content or practices of those sites.
      </p>

      <p className="mt-6 pt-4 border-t border-border/50 text-xs">
        For the current version of this disclaimer, visit{' '}
        <a href="https://fastaudio.cc/disclaimer" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
          fastaudio.cc/disclaimer
        </a>.
      </p>
    </LegalPage>
  )
}
